import React from "react";
import { ThemeProvider } from "@mui/material/styles"; //
import theme from "./theme"; //
import MainLayout from "./components/MainLayout";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import ModelZooPage from "./pages/ModelZooPage";
import V4PModelZooPage from "./pages/V4PModelZooPage";
import QMBlueprintPage from "./pages/QMBlueprintPage";

import NotFoundPage from "./pages/NotFoundPage";
import ProjectsPage from "./pages/ProjectsPage";
import DashboardPage from "./pages/DashboardPage";
import LandingPage from "./pages/LandingPage";
import AppZooPage from "./pages/AppZooPage";
import LogInPage from "./pages/LogInPage";
import NewUserPage from "./pages/NewUserPage";
import CreateProjectLayout from "./layouts/CreateProjectLayout";
import { createProjectRoutes } from "./routes/createProjectRoutes";
import ProtectedRoute from "./components/ProtectedRoute";
import PermissionRoute from "./components/PermissionRoute";

import { EditionProvider } from "./edition/EditionContext";

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/login" element={<LogInPage />} />
        <Route path="/new-user" element={<NewUserPage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="/landing-page" element={<LandingPage />} />

          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:projectId" element={<CreateProjectLayout />}>
            {createProjectRoutes}
          </Route>

          <Route
            path="/model-zoo"
            element={
              <PermissionRoute permission="view_model_zoo">
                <ModelZooPage />
              </PermissionRoute>
            }
          />
          <Route
            path="/v4p-model-zoo"
            element={
              <PermissionRoute permission="view_v4p_model_zoo">
                <V4PModelZooPage />
              </PermissionRoute>
            }
          />
          <Route path="/qm-blueprint" element={<QMBlueprintPage />} />
          <Route
            path="/app-zoo"
            element={
              <PermissionRoute permission="view_app_zoo">
                <AppZooPage />
              </PermissionRoute>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </>,
    ),
  );

  return (
    <EditionProvider>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </EditionProvider>
  );
}

export default App;
